import { ActionsUnion, createAction } from 'app/shared/utils/action-helpers';

// Models
import {
  SearchActionTypes,
  SearchRequest,
  TeamsSearchResponse,
} from 'app/modules/search/models';

export const teamsSearch = (payload: SearchRequest) =>
  createAction(SearchActionTypes.TEAMS_SEARCH, payload);

export const teamsSearchSuccess = (response: TeamsSearchResponse) =>
  createAction(SearchActionTypes.TEAMS_SEARCH_SUCCESS, response);

export const removeTeamFromSearch = (teamId: number) =>
  createAction(SearchActionTypes.REMOVE_TEAM_FROM_SEARCH, teamId);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const SearchReduxActions = {
  teamsSearchSuccess,
  removeTeamFromSearch,
};

export type SearchActions = ActionsUnion<typeof SearchReduxActions>;
